import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class EditCompetitionModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "competition", void 0);
    _defineProperty(this, "slug", '');
    _defineProperty(this, "nameEs", '');
    _defineProperty(this, "nameEu", '');
    _defineProperty(this, "nameEn", '');
    _defineProperty(this, "shortName", '');
    _defineProperty(this, "format", 'cup');
    _defineProperty(this, "color", '#ee2524');
    _defineProperty(this, "icon", '');
    _defineProperty(this, "allowsLineup", true);
    _defineProperty(this, "countsForLineupStanding", true);
    _defineProperty(this, "allowsBolilla", true);
    _defineProperty(this, "countsForBolillaStanding", true);
    _defineProperty(this, "allowsRatings", true);
    _defineProperty(this, "isOfficial", true);
    _defineProperty(this, "availableIcons", []);
    _defineProperty(this, "loadingIcons", true);
    _defineProperty(this, "uploadingIcon", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.competition = this.attrs.competition;
    if (this.competition) {
      this.slug = this.competition.slug() || '';
      this.nameEs = this.competition.nameEs() || this.competition.name() || '';
      this.nameEu = this.competition.nameEu() || '';
      this.nameEn = this.competition.nameEn() || '';
      this.shortName = this.competition.shortName() || '';
      this.format = this.competition.format() || 'cup';
      this.color = this.competition.color() || '#ee2524';
      this.icon = this.competition.icon() || '';
      this.allowsLineup = this.competition.allowsLineup() !== false;
      this.countsForLineupStanding = this.competition.countsForLineupStanding() !== false;
      this.allowsBolilla = this.competition.allowsBolilla() !== false;
      this.countsForBolillaStanding = this.competition.countsForBolillaStanding() !== false;
      this.allowsRatings = this.competition.allowsRatings() !== false;
      this.isOfficial = this.competition.isOfficial() !== false;
    }
    this.loadIcons();
  }
  className() {
    return 'EditCompetitionModal Modal--medium';
  }
  title() {
    return this.competition ? 'Editar Competición' : 'Nueva Competición';
  }
  loadIcons() {
    this.loadingIcons = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competition-icons'
    }).then(res => {
      if (res && res.data) {
        this.availableIcons = res.data;
      }
    }).catch(err => {
      console.error('Error loading icons:', err);
    }).finally(() => {
      this.loadingIcons = false;
      m.redraw();
    });
  }
  handleIconUpload(e) {
    const input = e.target;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    const formData = new FormData();
    formData.append('icon', file);
    this.uploadingIcon = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competition-icons/upload',
      body: formData,
      serialize: raw => raw
    }).then(res => {
      if (res && res.filename) {
        this.icon = res.filename;
        this.loadIcons();
        app.alerts.show({
          type: 'success'
        }, 'Icono subido correctamente.');
      }
    }).catch(err => {
      console.error('Error uploading icon:', err);
      app.alerts.show({
        type: 'error'
      }, 'Error al subir el icono.');
    }).finally(() => {
      this.uploadingIcon = false;
      m.redraw();
    });
  }
  content() {
    return m("div", {
      className: "Modal-body",
      style: "padding: 24px;"
    }, m("form", {
      onsubmit: this.onsubmit.bind(this)
    }, m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 18px; margin-bottom: 20px;"
    }, m("h4", {
      style: "margin: 0 0 16px 0; font-size: 1.1em; color: var(--heading-color); display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-tag",
      style: "color: #ee2524;"
    }), " Nombres & Slug"), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; font-size: 0.9em; display: block; margin-bottom: 6px;"
    }, "Nombre en Castellano *"), m("input", {
      className: "FormControl",
      required: true,
      placeholder: "Ej: Champions League, Euskal Herriko Kopa...",
      value: this.nameEs,
      oninput: e => {
        this.nameEs = e.target.value;
        if (!this.competition && !this.slug) {
          this.slug = this.nameEs.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        }
      }
    })), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 12px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Nombre en Euskera"), m("input", {
      className: "FormControl",
      placeholder: "Ej: Txapeldunen Liga",
      value: this.nameEu,
      oninput: e => this.nameEu = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Nombre en Ingl\xE9s"), m("input", {
      className: "FormControl",
      placeholder: "Ej: UEFA Champions League",
      value: this.nameEn,
      oninput: e => this.nameEn = e.target.value
    }))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 12px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Nombre Corto / Abreviatura"), m("input", {
      className: "FormControl",
      placeholder: "Ej: UCL, Copa, EHK",
      value: this.shortName,
      oninput: e => this.shortName = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Slug Identificador *"), m("input", {
      className: "FormControl",
      required: true,
      placeholder: "Ej: champions-league",
      value: this.slug,
      oninput: e => this.slug = e.target.value
    })))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 18px; margin-bottom: 20px;"
    }, m("h4", {
      style: "margin: 0 0 16px 0; font-size: 1.1em; color: var(--heading-color); display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-palette",
      style: "color: #ff9800;"
    }), " Formato, Color & Icono"), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 14px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Formato de Competici\xF3n"), m("select", {
      className: "FormControl",
      value: this.format,
      onchange: e => this.format = e.target.value
    }, m("option", {
      value: "league"
    }, "Liga regular"), m("option", {
      value: "cup"
    }, "Torneo de Copa (eliminatoria)"), m("option", {
      value: "tournament"
    }, "Torneo mixto / fase grupos"), m("option", {
      value: "friendly"
    }, "Amistoso / Trofeo verano"))), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Color identificativo"), m("div", {
      style: "display: flex; gap: 10px; align-items: center;"
    }, m("input", {
      type: "color",
      value: this.color,
      oninput: e => this.color = e.target.value,
      style: "width: 44px; height: 38px; padding: 2px; border-radius: 6px; cursor: pointer; border: 1px solid rgba(255,255,255,0.2); background: transparent;"
    }), m("input", {
      className: "FormControl",
      value: this.color,
      oninput: e => this.color = e.target.value,
      style: "flex: 1;",
      placeholder: "#ee2524"
    }), m("span", {
      className: "CompBadge",
      style: "background: ".concat(this.color, "22; color: ").concat(this.color, "; border: 1px solid ").concat(this.color, "55; padding: 4px 10px; font-weight: bold; border-radius: 6px; font-size: 0.85em;")
    }, "Preview")))), m("div", {
      className: "Form-group",
      style: "margin-top: 14px;"
    }, m("label", {
      style: "font-weight: 600; font-size: 0.85em; display: block; margin-bottom: 6px;"
    }, "Icono oficial"), this.loadingIcons ? m(LoadingIndicator, {
      size: "small"
    }) : m("div", {
      style: "display: flex; gap: 10px; align-items: center; flex-wrap: wrap;"
    }, m("select", {
      className: "FormControl",
      style: "flex: 1; min-width: 220px;",
      value: this.icon,
      onchange: e => this.icon = e.target.value
    }, m("option", {
      value: ""
    }, "-- Sin icono asignado --"), this.availableIcons.map(ic => m("option", {
      value: ic.filename
    }, ic.name, " (", ic.filename, ")"))), this.icon && m("div", {
      style: "display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 38px; border-radius: 8px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.15);"
    }, m("img", {
      src: "/assets/extensions/nagusi-match-ratings/competitions/".concat(this.icon),
      alt: "",
      style: "width: 24px; height: 24px; object-fit: contain;"
    })), m("label", {
      className: "Button Button--secondary",
      style: "cursor: pointer; display: inline-flex; align-items: center; gap: 6px; border-radius: 6px; padding: 8px 12px;"
    }, m("i", {
      className: "fas fa-upload"
    }), " Subir Icono", m("input", {
      type: "file",
      accept: ".svg,.png,.webp",
      style: "display: none;",
      onchange: this.handleIconUpload.bind(this)
    })), this.uploadingIcon && m(LoadingIndicator, {
      size: "small"
    })))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 18px; margin-bottom: 24px;"
    }, m("h4", {
      style: "margin: 0 0 16px 0; font-size: 1.1em; color: var(--heading-color); display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-gamepad",
      style: "color: #4caf50;"
    }), " Reglas de Juegos & Computabilidad"), m("div", {
      style: "display: flex; flex-direction: column; gap: 14px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05);"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\u26BD 11 Aldeanos: Permitir pron\xF3sticos"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Los usuarios pueden guardar su 11 para los partidos de esta competici\xF3n.")), m("input", {
      type: "checkbox",
      checked: this.allowsLineup,
      onchange: e => this.allowsLineup = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })), m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05); margin-left: 20px;"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\uD83C\uDFC6 11 Aldeanos: Computar para la Txapela General"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Si est\xE1 desmarcado, se juega como amistoso y sus puntos NO sumar\xE1n a la clasificaci\xF3n general anual.")), m("input", {
      type: "checkbox",
      checked: this.countsForLineupStanding,
      onchange: e => this.countsForLineupStanding = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })), m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05);"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\uD83D\uDD2E La Bolilla: Permitir pron\xF3sticos"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Los usuarios pueden predecir resultado y primer goleador.")), m("input", {
      type: "checkbox",
      checked: this.allowsBolilla,
      onchange: e => this.allowsBolilla = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })), m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05); margin-left: 20px;"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\uD83E\uDD47 La Bolilla: Computar para la Clasificaci\xF3n Anual"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Si est\xE1 desmarcado, los aciertos en este torneo no punt\xFAan para el trofeo anual de la Bolilla.")), m("input", {
      type: "checkbox",
      checked: this.countsForBolillaStanding,
      onchange: e => this.countsForBolillaStanding = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })), m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05);"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\u26F0\uFE0F Pastor del Gorbea: Computar notas de jugadores"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Si est\xE1 activado, los votos de los partidos computan para las medias del Trofeo Pastor del Gorbea.")), m("input", {
      type: "checkbox",
      checked: this.allowsRatings,
      onchange: e => this.allowsRatings = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })), m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; background: rgba(255,255,255,0.02); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05);"
    }, m("div", null, m("strong", {
      style: "color: var(--heading-color); display: block; font-size: 0.95em;"
    }, "\uD83D\uDEE1\uFE0F Competici\xF3n Oficial"), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, "Marca si es torneo oficial de FIFA/UEFA/RFEF o partido amistoso / pretemporada.")), m("input", {
      type: "checkbox",
      checked: this.isOfficial,
      onchange: e => this.isOfficial = e.target.checked,
      style: "width: 20px; height: 20px; cursor: pointer;"
    })))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 12px; margin-top: 10px;"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: this.hide.bind(this),
      style: "border-radius: 8px; padding: 10px 18px;"
    }, "Cancelar"), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading,
      style: "border-radius: 8px; padding: 10px 24px; font-weight: bold;"
    }, this.competition ? 'Guardar Cambios' : 'Crear Competición'))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const data = {
      slug: this.slug,
      nameEs: this.nameEs,
      nameEu: this.nameEu || null,
      nameEn: this.nameEn || null,
      shortName: this.shortName || null,
      format: this.format,
      color: this.color,
      icon: this.icon || null,
      allowsLineup: this.allowsLineup,
      countsForLineupStanding: this.countsForLineupStanding,
      allowsBolilla: this.allowsBolilla,
      countsForBolillaStanding: this.countsForBolillaStanding,
      allowsRatings: this.allowsRatings,
      isOfficial: this.isOfficial
    };
    const isEdit = !!this.competition;
    const url = isEdit ? app.forum.attribute('apiUrl') + "/nagusi/match-ratings/competitions/".concat(this.competition.id()) : app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competitions';
    const method = isEdit ? 'PATCH' : 'POST';
    app.request({
      method,
      url,
      body: {
        data: {
          type: 'nagusi_competitions',
          attributes: data
        }
      }
    }).then(response => {
      app.alerts.show({
        type: 'success'
      }, isEdit ? 'Competición actualizada con éxito.' : 'Competición creada con éxito.');
      this.hide();
      const savedComp = response && response.data ? app.store.pushObject(response.data) : null;
      if (this.attrs.onSaved) {
        this.attrs.onSaved(savedComp);
      }
    }).catch(err => {
      console.error('Error saving competition:', err);
      const msg = err && err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].detail || err && err.response && err.response.error || 'Error al guardar la competición.';
      app.alerts.show({
        type: 'error'
      }, msg);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditCompetitionModal', EditCompetitionModal);